
{
  "familyId": "MET-DRIEHOEK-SOORTEN",
  "questions": [
    {
      "id": "MET-DRIEHOEK-SOORTEN-001",
      "familyId": "MET-DRIEHOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "driehoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een driehoek heeft drie zijden van gelijke lengte. Hoe heet deze driehoek?",
      "options": ["Gelijkzijdig", "Gelijkbenig", "Rechthoekig", "Ongelijkzijdig"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Soorten driehoeken",
            "content": "Gelijkzijdig: 3 gelijke zijden, 3 hoeken van 60°. Gelijkbenig: 2 gelijke zijden. Rechthoekig: 1 hoek van 90°. Ongelijkzijdig: alle zijden verschillend.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "driehoek_gelijkzijdig",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Een driehoek met 3 gelijke zijden heet gelijkzijdig. Waarom? Als alle zijden even lang zijn, zijn ook alle hoeken gelijk: 180° ÷ 3 = 60° per hoek. Controleer: 60° + 60° + 60° = 180° ✓. Onthoud: gelijk-zijdig = gelijke zijden.",
        "solutionSteps": [
          "Kijk naar de zijden: alle 3 zijn gelijk",
          "3 gelijke zijden = gelijkzijdig",
          "Alle hoeken zijn dan ook gelijk: 60°",
          "Controleer: 60° + 60° + 60° = 180° ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Drie gelijke zijden = gelijkzijdig. Alle hoeken zijn dan 60°.",
          "1": "Je dacht waarschijnlijk aan gelijkbenig. Maar gelijkbenig heeft slechts 2 gelijke zijden, niet 3. Onthoud: gelijk-benig = 2 gelijke 'benen'.",
          "2": "Rechthoekig gaat over hoeken (1 hoek van 90°), niet over gelijke zijden. Een driehoek kan rechthoekig én gelijkbenig zijn, maar dat is hier niet het geval.",
          "3": "Ongelijkzijdig betekent dat alle zijden verschillend zijn. Hier zijn juist alle 3 de zijden gelijk."
        }
      }
    },
    {
      "id": "MET-DRIEHOEK-SOORTEN-002",
      "familyId": "MET-DRIEHOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "driehoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een driehoek heeft zijden van 5 cm, 5 cm en 8 cm. Welk type driehoek is dit?",
      "options": ["Gelijkbenig", "Gelijkzijdig", "Rechthoekig", "Ongelijkzijdig"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijkbenig",
            "content": "Gelijkbenig = precies 2 zijden even lang. De twee gelijke zijden heten 'benen'. De derde zijde heet de 'basis'. De hoeken tegenover de gelijke zijden zijn ook gelijk.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "driehoek_gelijkbenig",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Twee zijden zijn gelijk (5 cm en 5 cm), de derde is anders (8 cm). Dat is een gelijkbenige driehoek. De twee gelijke zijden zijn de 'benen'.",
        "solutionSteps": [
          "5 cm = 5 cm (twee gelijke zijden)",
          "8 cm is anders",
          "2 gelijke zijden = gelijkbenig"
        ],
        "distractorExplanations": {
          "0": "Goed! Twee gelijke zijden = gelijkbenig.",
          "1": "Gelijkzijdig zou betekenen dat alle 3 zijden gelijk zijn (5, 5, 5). Maar de derde zijde is 8.",
          "2": "Rechthoekig gaat over hoeken (90°), niet over gelijke zijden.",
          "3": "Ongelijkzijdig zou betekenen dat alle zijden verschillend zijn. Maar twee zijden zijn gelijk."
        }
      }
    },
    {
      "id": "MET-DRIEHOEK-SOORTEN-003",
      "familyId": "MET-DRIEHOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "driehoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een driehoek heeft hoeken van 90°, 45° en 45°. Hoe heet deze driehoek?",
      "options": ["Rechthoekig (en gelijkbenig)", "Gelijkzijdig", "Stomphoekig", "Ongelijkzijdig"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rechthoekige driehoek",
            "content": "Een rechthoekige driehoek heeft één hoek van precies 90° (een rechte hoek). De zijde tegenover de rechte hoek heet de 'hypotenusa' — dat is altijd de langste zijde.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "driehoek_rechthoekig",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Er is een hoek van 90° → rechthoekig. De andere twee hoeken zijn gelijk (45° en 45°) → ook gelijkbenig. Het is dus een rechthoekige gelijkbenige driehoek.",
        "solutionSteps": [
          "90° = rechte hoek → rechthoekig",
          "45° = 45° → twee gelijke hoeken → gelijkbenig",
          "Combinatie: rechthoekig én gelijkbenig"
        ],
        "distractorExplanations": {
          "0": "Goed! 90° maakt het rechthoekig, en de twee gelijke hoeken (45°) maken het ook gelijkbenig.",
          "1": "Gelijkzijdig heeft 3 hoeken van 60°, niet 90°-45°-45°.",
          "2": "Stomphoekig heeft een hoek GROTER dan 90°. 90° is precies recht, niet stomp.",
          "3": "Ongelijkzijdig gaat over zijden, niet over hoeken. Bovendien zijn twee hoeken gelijk."
        }
      }
    },
    {
      "id": "MET-DRIEHOEK-SOORTEN-004",
      "familyId": "MET-DRIEHOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "driehoek_soorten",
      "questionType": "multiple_choice",
      "question": "Welke driehoek kan NIET bestaan?",
      "options": ["Een driehoek met twee rechte hoeken (90° + 90°)", "Een driehoek met één stompe hoek", "Een gelijkbenige rechthoekige driehoek", "Een driehoek met drie scherpe hoeken"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeksom driehoek",
            "content": "De drie hoeken van een driehoek tellen altijd op tot 180°. Twee rechte hoeken = 90° + 90° = 180°. Dan is er geen ruimte meer voor de derde hoek!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "driehoek_onmogelijk",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De hoeken van een driehoek tellen altijd op tot 180°. Twee rechte hoeken = 90° + 90° = 180°. Dan is er 0° over voor de derde hoek — dat kan niet!",
        "solutionSteps": [
          "Hoeksom driehoek = 180°",
          "90° + 90° = 180° (al vol!)",
          "Derde hoek zou 0° moeten zijn → onmogelijk"
        ],
        "distractorExplanations": {
          "0": "Goed! Twee rechte hoeken = 180°, dan is er geen ruimte voor een derde hoek.",
          "1": "Een driehoek met één stompe hoek kan wel. Bijv. 120° + 30° + 30° = 180°.",
          "2": "Een gelijkbenige rechthoekige driehoek kan wel: 90° + 45° + 45° = 180°.",
          "3": "Drie scherpe hoeken kan ook. Bijv. 60° + 60° + 60° = 180° (gelijkzijdig)."
        }
      }
    },
    {
      "id": "MET-DRIEHOEK-SOORTEN-005",
      "familyId": "MET-DRIEHOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "driehoek_soorten",
      "questionType": "matching",
      "question": "Koppel elk type driehoek aan de juiste eigenschap.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "Gelijkzijdig", "right": "3 gelijke zijden" },
          { "left": "Gelijkbenig", "right": "2 gelijke zijden" },
          { "left": "Rechthoekig", "right": "1 hoek van 90°" },
          { "left": "Stomphoekig", "right": "1 hoek groter dan 90°" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Driehoeksoorten",
            "content": "Gelijkzijdig: 3 gelijke zijden. Gelijkbenig: 2 gelijke zijden. Rechthoekig: 1 hoek van 90°. Stomphoekig: 1 hoek > 90°.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "driehoek_soorten_match",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Gelijkzijdig = 3 gelijke zijden (en 3 hoeken van 60°). Gelijkbenig = 2 gelijke zijden. Rechthoekig = 1 hoek van 90°. Stomphoekig = 1 hoek groter dan 90°. Tip: de naam zegt vaak al wat het is!",
        "solutionSteps": [
          "Gelijkzijdig → 3 gelijke zijden (gelijk + zijdig)",
          "Gelijkbenig → 2 gelijke zijden (de 'benen')",
          "Rechthoekig → 1 hoek van 90° (rechte hoek)",
          "Stomphoekig → 1 hoek groter dan 90° (stompe hoek)"
        ],
        "distractorExplanations": {
          "0": "Goed gekoppeld! Gelijkzijdig = 3 gelijke zijden.",
          "1": "Gelijkbenig heeft 2 gelijke zijden, niet 3. De twee gelijke zijden heten de 'benen'.",
          "2": "Rechthoekig gaat over hoeken: precies 1 hoek van 90°. De langste zijde heet de hypotenusa.",
          "3": "Stomphoekig heeft 1 hoek groter dan 90°. Stomp = groter dan recht."
        }
      }
    }
  ]
}
